import { AppConfig } from '@spjp/model/app-config';

export const environment: AppConfig = {
    production: false,
    apiUri: null,
    cmsUri: null,
    testCmsUri: null,
    identityUri: null,
    backofficeIdentityUri: null,
    tokyoIdentityUri: null,
    niigataIdentityUri: null,
    googleApiKey: null,
    allowLinksToCms: false,
    analyticsUri: null,
    addressServiceUri: null,
    checkDuplicatedRegistrations: true,
    canAccessPreferenceCenter: true,
    stripeProductId: null,
    aiConnectionString: null
};
